
//export const IS_PRODUCTION_NODE_ENV = (process.env.NODE_ENV === 'production');
//export const IS_DEVELOPMENT_NODE_ENV = (process.env.NODE_ENV === 'development');
export const IS_STAGING = ( process.env.VUE_APP_IS_STAGING === '1' ) ? true : false;
export const PROJECT_ID = IS_STAGING ? 'kioskapp-staging' : 'kioskapp-f4a12';

console.log(`process.env.NODE_ENV=${process.env.NODE_ENV}`);
//console.log(`IS_DEVELOPMENT_NODE_ENV=${IS_DEVELOPMENT_NODE_ENV}`);
console.log(`IS_STAGING=${IS_STAGING}`);
console.log(`PROJECT_ID=${PROJECT_ID}`);
